__turbopack_context__.v({
  "control": "LanguagePicker-module__ZfnJWa__control",
  "icon": "LanguagePicker-module__ZfnJWa__icon",
  "label": "LanguagePicker-module__ZfnJWa__label",
});
